import * as React from "react";
import { useLayoutEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Drawer as MantineDrawer } from "@mantine/core";
import styled, { css } from "styled-components";
import useDisclosure from "util/hooks/useDisclosure";
const StyledDrawer = styled(MantineDrawer)(
  ({ theme }) => css`
    .mantine-Drawer-content,
    .mantine-Drawer-header {
      background-color: ${theme.colors.global.contentBackground};
    }

    .mantine-Drawer-content {
      display: flex;
      flex-direction: column;

      &.double {
        flex-basis: calc(var(--drawer-size) * 2);
      }
    }

    .mantine-Drawer-body {
      flex: 1;
    }

    .mantine-Drawer-title {
      width: 94%;
    }
  `
);
const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  overflow: hidden;
  width: 100%;
`;
const Title = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.h1};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-height: 1.2;
  `
);
const DRAWER_OPEN_DELAY_MS = 80;
const DRAWER_CLOSE_DELAY_MS = 200;
export const getDrawerPropsByLevel = ({
  parentSize,
  level = 0,
  parentPosition = "right"
}) => ({
  position: parentPosition,
  withOverlay: level === 0,
  styles: parentPosition ? { inner: { [parentPosition]: `calc((var(--drawer-size-${parentSize}) + 0.8rem) * ${level})` } } : void 0,
  overlayProps: { zIndex: 1030 + level }
});
const Drawer = ({
  title,
  double = false,
  parentSize = void 0,
  level = 0,
  parentPosition = "right",
  ...props
}) => {
  const [opened, { open, close }] = useDisclosure(false);
  const closeTimeoutRef = useRef(null);
  useLayoutEffect(() => {
    setTimeout(() => open(), DRAWER_OPEN_DELAY_MS);
    return () => {
      if (closeTimeoutRef.current !== null) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }
    };
  }, [open]);
  const handleClose = () => {
    close();
    closeTimeoutRef.current = setTimeout(() => {
      var _a;
      return (_a = props.onClose) == null ? void 0 : _a.call(props);
    }, DRAWER_CLOSE_DELAY_MS);
  };
  return ReactDOM.createPortal(
    /* @__PURE__ */ React.createElement(
      StyledDrawer,
      {
        offset: 15,
        padding: "lg",
        radius: 5,
        zIndex: 1032,
        classNames: { content: double ? "double" : "" },
        title: /* @__PURE__ */ React.createElement(TitleWrapper, null, /* @__PURE__ */ React.createElement(Title, null, title)),
        ...getDrawerPropsByLevel({ parentSize, level, parentPosition }),
        ...props,
        opened,
        onClose: handleClose
      }
    ),
    document.body
  );
};
export default Drawer;
